<ng-container *transloco="let t; read: 'user'">
  <div class="p-5">
    <div class="flex flex-row">
      <div class="basis-full">
        <drdp-title
          [title]="
            t('manageEnrollment.students.pageTitle', {
              classroom:
                classroomName ??
                t('manageEnrollment.students.classroomNameNotFound')
            })
          "
        ></drdp-title>
        <div class="pb-5 flex items-center justify-between">
          <h2>
            {{
              t('manageEnrollment.students.ratingPeriodLabel', {
                ratingPeriod:
                  ratingPeriodName ??
                  t('manageEnrollment.students.ratingPeriodNotFound')
              })
            }}
          </h2>
          <a
            [routerLink]="['/classrooms']"
            [queryParamsHandling]="'preserve'"
            class="text-drdpblue-300 hover:underline"
          >{{ t('manageEnrollment.students.backToClassrooms') }}</a>
        </div>
      </div>
      @if (canBatchUpdateSped) {
        <div class="flex justify-end items-center">
          <drdp-btn type="button" additionalClasses="lg:m-2 xl:m-0 inline-block" (click)="batchSpedExit()" color="outline">{{ t('manageEnrollment.students.batchSpedExitDate') }}</drdp-btn>
        </div>
      }
    </div>

    @if (showTable) {
      <drdp-container>
        <div class="w-full">
          <drdp-add-edit-table
            [dataSource]="dataSource"
            [tableData]="tableData"
            [columns]="tableColumns"
            (iconActionItem)="onIconClick($event)"
            (actionIconClicked)="onActionItemClicked($event)"
            >
          </drdp-add-edit-table>
        </div>
      </drdp-container>
    }
  </div>
  <mat-paginator
    class="mb-12"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [length]="totalData"
    [pageIndex]="pageIndex"
    (page)="paginate($event)"
    >
  </mat-paginator>
</ng-container>
